import { useState } from 'react';
import ColumnList from './ColumnList';
import { userAppContext } from '../../../../../context/Context';

function TableColumnsMenu({
  view,
  tab,
  setIsColumnSelectOpen,
  columnVisibilityModel,
  setColumnVisibilityModel,
}) {
  const { groups, isAuthenticated } = userAppContext();
  const isAcademic = groups?.includes('ROLE_ACADEMIC');

  const [allSelected, setAllSelected] = useState(false);

  const selectAllItems = () => {
    setColumnVisibilityModel((prevItems: Record<string, boolean> | undefined) => {
      const prev = prevItems ?? {};
      const updatedItems: Record<string, boolean> = {};
      Object.keys(prev).forEach(column => {
        updatedItems[column] = !allSelected;
      });
      return { ...updatedItems };
    });
    setAllSelected(!allSelected);
  };
  return (
    <div className="external-menu">
      <ul className="column-item">
        <ColumnList
          columnVisibilityModel={columnVisibilityModel}
          setColumnVisibilityModel={setColumnVisibilityModel}
          view={view}
          tab={tab}
        />
      </ul>
      <div className="action-buttons">
        <button onClick={selectAllItems} className="select">
          {allSelected ? 'Clear All' : 'Select All'}
        </button>
        <button onClick={() => setIsColumnSelectOpen(false)} className="select">
          Close
        </button>
      </div>
    </div>
  );
}

export default TableColumnsMenu;
